import { useEffect, useState } from "react";
import { api } from "@/api";
import { LayoutAutenticado } from "@/componentes/LayoutAutenticado";

export default function VerRegulamento() {
  const [reg, setReg] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/publico/regulamento");
      setReg(data);
    })();
  }, []);

  return (
    <LayoutAutenticado>
      <div data-testid="pagina-regulamento">
        <div className="mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Regras</div>
          <h1 className="font-heading text-4xl font-bold uppercase mt-1">Regulamento</h1>
          {reg && (
            <div className="text-xs text-white/40 mt-2">
              Versão {reg.versao} {reg.ativo ? "(ativa)" : ""}
            </div>
          )}
        </div>

        <article className="surface-card rounded-2xl p-6 md:p-10 whitespace-pre-wrap text-sm">
          {reg?.conteudo || "Carregando..."}
        </article>
      </div>
    </LayoutAutenticado>
  );
}
